import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Separator from '../../../../core/layout/Separator';
import AnswersInputContainer from '../inputs/AnswersInputContainer';
import TranslationInputContainer from '../inputs/TranslationInputContainer';
import TextInput from '../../../../core/form/TextInput';
import Audios from '../inputs/Audios';
import Column from '../../../../core/layout/Column';
import Row from '../../../../core/layout/Row';
import Divider from '../../../../core/layout/Divider';
import LocalFileInput from '../../../../core/form/LocalFileInput';

const SingleChoiceItemForm = (props) => (
  <div>
    <Row>
      <Column size={12}>
        <TextInput
          required
          label="Text"
          fieldType="textarea"
          disabled={props.submitting || props.disabled}
          value={get(props.values, 'text', '')}
          onChange={(value) => props.onChange('text', value)}
          errorText={get(props.errors, 'text', '')}
        />
      </Column>
    </Row>
    {!props.isTestItem && (
      <TranslationInputContainer
        onChange={props.onChange}
        submitting={props.submitting}
        values={props.values}
        errors={props.errors}
        disabled={props.disabled}
      />
    )}
    <Row>
      <Column size={4}>
        <Audios
          audioPath="audio"
          generatedAudioPath="generatedAudio"
          values={props.values}
          submitting={props.submitting}
          disabled={props.disabled}
          onChange={props.onChange}
          errors={props.errors}
        />
      </Column>
      {props.hasImage && (
        <Column size={4}>
          <LocalFileInput
            accept="image"
            cropSize={{ width: 960, height: 640 }}
            disabled={props.disabled}
            label="Upload an image to the item"
            value={get(props.values, 'image', '')}
            onChange={(file) => props.onChange('image', file)}
            errorText={get(props.errors, 'image', '')}
          />
        </Column>
      )}
    </Row>
    <Separator size="xs" />
    {props.showPostPhrase && !props.isTestItem && (
      <TextInput
        label="Post Phrase"
        disabled={props.submitting || props.disabled}
        value={get(props.values, 'postPhrase', '')}
        onChange={(value) => props.onChange('postPhrase', value)}
        description={get(props.errors, 'postPhrase', '')}
        fieldValidation={get(props.errors, 'postPhrase', null) && 'error'}
      />
    )}
    {props.showPostPhrase && !props.isTestItem && (
      <Audios
        audioPath="postPhraseAudio"
        generatedAudioPath="generatedPostPhraseAudio"
        values={props.values}
        disabled={props.disabled}
        onChange={props.onChange}
        errors={props.errors}
      />
    )}
    <Divider title="Answers" />
    <AnswersInputContainer
      label="Answer text"
      value={get(props.values, 'answers', [])}
      onChange={(answers) => props.onChange('answers', answers)}
      errorText={get(props.errors, 'answers', '')}
      type={props.type}
      hasImage={props.hasImage}
      disabled={props.disabled}
    />
  </div>
);

SingleChoiceItemForm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  submitting: PropTypes.bool,
  disabled: PropTypes.bool,
  isTestItem: PropTypes.bool,
  type: PropTypes.oneOf(['SINGLE_CHOICE_TEXT', 'SINGLE_CHOICE_AUDIO', 'SINGLE_CHOICE_IMAGE']).isRequired,
  showPostPhrase: PropTypes.bool,
  hasImage: PropTypes.bool,
};

SingleChoiceItemForm.defaultProps = {
  values: {},
  errors: {},
  submitting: false,
  disabled: false,
  showPostPhrase: false,
  isTestItem: false,
  hasImage: false,
};

export default SingleChoiceItemForm;
